/**
 * Smart sub-dropdown positioning.
 *
 * The panel is always 246 px wide and pinned 18 px from the right viewport edge.
 * Preferred:  open at the same Y as the triggering row (to the right of parent).
 * Fallback:   open below the triggering row when the panel's left edge would
 *             overlap the parent dropdown (not enough horizontal room).
 *
 * @param {DOMRect} triggerRect  - bounding rect of the row that opens the sub-panel
 * @param {object}  [opts]
 * @param {number}  [opts.width=246]  - sub-panel width in px
 * @param {number}  [opts.gap=4]      - vertical gap when falling back to below
 * @param {number}  [opts.margin=18]  - fixed distance from right viewport edge
 */
export function positionSubDropdown(triggerRect, { width = 246, gap = 4, margin = 18 } = {}) {
  const vw = window.innerWidth

  // The panel is always anchored at right: 18px from the viewport
  const panelLeft = vw - margin - width

  // "Fits to the right" means the panel's left edge is at or beyond
  // the parent dropdown's right edge (no horizontal overlap)
  const fitsRight = panelLeft >= triggerRect.right

  return {
    position: fitsRight ? 'right' : 'below',
    style: {
      top:   fitsRight
        ? `${triggerRect.top}px`
        : `${triggerRect.bottom + gap}px`,
      right: `${margin}px`,
      width: `${width}px`,
    },
  }
}
